import { useState, type ReactNode } from "react";
import styles from "../../../shared/components/shell.module.css";

/**
 * „25 Codes erzeugen“ – der normale Zug, wenn eine Klasse anfängt.
 *
 * Ohne eigene Karte: er steht direkt über „Kärtchen als PDF“, weil das die
 * Reihenfolge der Handlung ist – erst erzeugen, dann drucken. Als eigene Karte
 * stand er unter der Codeliste und damit hinter dem Ergebnis seiner Arbeit.
 */
export function CodeGenerator({
  pending,
  error,
  onGenerate,
  children,
}: {
  pending: boolean;
  error: string | null;
  onGenerate: (count: number) => void;
  /** Steht in derselben Zeile: erzeugen und drucken sind ein Handgriff. */
  children?: ReactNode;
}) {
  const [count, setCount] = useState(25);

  return (
    <div className={styles.spaced}>
      <h2 className={styles.title} style={{ fontSize: "1.15rem" }}>
        Codes erzeugen
      </h2>
      {error && <div className={`${styles.notice} ${styles.noticeError}`}>{error}</div>}
      {/* Die Marke der Führung sitzt an der ZEILE und nicht an einem der beiden
          Knöpfe: erzeugen und drucken sind ein Handgriff, und vor dem ersten
          Satz Codes gibt es den Druckknopf noch nicht. Ein Ring, der erst
          erscheint, wenn die Arbeit getan ist, führt niemanden. */}
      <div className={styles.row} data-tour="kaertchen">
        <label htmlFor="count">Anzahl</label>
        <input
          id="count"
          className={styles.field}
          style={{ width: 90 }}
          type="number"
          min={1}
          max={40}
          value={count}
          onChange={(e) => setCount(Number(e.target.value))}
        />
        <button
          type="button"
          className={styles.button}
          disabled={pending || count < 1}
          onClick={() => onGenerate(count)}
        >
          {pending ? "Wird erzeugt …" : `${count} Codes erzeugen`}
        </button>
        {children}
      </div>
    </div>
  );
}
